/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import {Button} from 'react-bootstrap';
import Props from './Props';

class PersonalName extends React.Component<Props> {

	static defaultProps: Props = {
		onResolvePersonalNameSubmit: () => {
			// do nothing
		},
		submitDisabled: false
	};

	handleResolvePersonalNameSubmit = (): void => {
		const props: Readonly<Props> = this.props;

		if (!props.submitDisabled)
			props.onResolvePersonalNameSubmit();
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<Button
				type="submit"
				className="float-end"
				variant="primary"
				onClick={this.handleResolvePersonalNameSubmit}
				disabled={props.submitDisabled}>
				{'Probeer opnieuw'}
			</Button>
		);
	}
}

export default PersonalName;
